import PSCampaign from "PSCampaign";
import jQuery from "jQuery";
import * as unity from "./unity.js";
import * as campaigns from "./campaigns.js";

let activeWebview = null;

export function init(name) {
    console.log("[w] init webview", name);
}

export function load(name, url) {
    console.log("[w] load webview", arguments);

    campaigns.hideCarousel();
    campaigns.setAvoidHideCarousel(true);
    activeWebview = name;
    campaigns.carousel.registerObserver(onWebViewDecision);
    campaigns.carousel.generate({
        name: {
            url,
            id: name
        }
    });
    sendWebViewLoaded();
}

function onWebViewDecision(_, idAction, decision) {
    console.log("[w] onWebViewDecision", arguments);
    if (decision.type === PSCampaign.FrameMessageType.KILL) {
        hide(activeWebview);
        campaigns.hideCarousel();
    } else {
        if (decision.data.type === "close") {
            hide(activeWebview);
            campaigns.hideCarousel();
        }
        unity.sendData(unity.webViewPlugin, decision.data);
    }
}

export function setMargins(name, left, top, right, bottom) {
    let player = jQuery("#unityContainer");
    let width = player.width();
    let height = player.height();
    let lp = left / width * 100;
    let tp = top / height * 100;
    let wp = (width - left - right) / width * 100;
    let hp = (height - top - bottom) / height * 100;

    this.iframe(name)
        .css("left", lp + "%")
        .css("top", tp + "%")
        .css("width", wp + "%")
        .css("height", hp + "%");
}

export function show(name) {
    if (activeWebview === name) {
        console.log("[w] showing: ", name);

        campaigns.setAvoidHideCarousel(true);
        campaigns.carousel.show(name);
    } else {
        console.log("[w] ignoring showing: ", name, activeWebview);
    }
}

export function hide(name) {
    if (activeWebview === name) {
        console.log("[w] hiding: ", name);
        campaigns.setAvoidHideCarousel(false);
        campaigns.carousel.hide();
    } else {
        console.log("[w] ignoring hiding: ", name, activeWebview);
    }
}

export function evaluateJS(_name, js) {
    eval(js);
}

function sendWebViewLoaded() {
    const params = {
        type: "loadFinished",
        status: "OK"
    };
    unity.sendData(unity.webViewPlugin, params);
}

campaigns.onCarouselClosed(function () {
    console.log("[w] onCarouselClosed: ", activeWebview);
    activeWebview = null;
});